module.exports = __webpack_public_path__ + "img/merchantCard.ec8b6e5f.png";